<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="餐桌详情"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="5">小程序链接：</el-col>
        <el-col :span="19">
          <span ref="path">
            dine/list/list?restaurantId={{
              showForm.basic.restaurantId
            }}&deskTitle={{ showForm.title }}
          </span>
          <el-button
            type="primary"
            class="ml-10"
            @click="copy"
            size="mini"
            plain
          >
            复制
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">餐桌名称:</el-col>
        <el-col :span="19">{{ showForm.title }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">所属门店:</el-col>
        <el-col :span="19">
          {{ row.branch && row.branch.title }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">所属餐厅:</el-col>
        <el-col :span="19">
          {{ row.restaurant && row.restaurant.title }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { findDesk } from '@/api/food'
export default {
  name: 'DeskDetail',
  emits: ['fetch-data'],
  data() {
    return {
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const deskId = row.deskId
      this.row = row
      const data = await findDesk({
        deskId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
    copy() {
      const text = this.$refs.path.innerText
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制成功')
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
